window.addEventListener('DOMContentLoaded', () => {
    new Swiper('.swiper.reassurance__container', {
        slidesPerView: 2,
        centeredSlides: true,
        centeredSlidesBounds: true,
        // start to 2nd slide
        initialSlide: 1,
        // Responsive breakpoints
        breakpoints: {
            950: {
                slidesPerView: 5,
                allowTouchMove: false
            }
        }
    });
});
